import axios from "axios";

const DEFAULT_API_URL = "https://gersgarage.herokuapp.com/api";

const normalizeApiUrl = (url) => `${url.replace(/\/+$/, "")}/`;
const getToken = () => {
  if (typeof window === "undefined") {
    return "";
  }

  return window.localStorage.getItem("token") || "";
};

const BASE_URL = normalizeApiUrl(process.env.REACT_APP_API_URL || DEFAULT_API_URL);

export const publicRequest = axios.create({
  baseURL: BASE_URL,
});

export const userRequest = axios.create({
  baseURL: BASE_URL,
});

userRequest.interceptors.request.use((config) => {
  const token = getToken();

  if (token) {
    config.headers.token = `Bearer ${token}`;
  }

  return config;
});
